export const customObjectsCustomObjectTypeSchema = "/data_objects/data_object_type_schema" as const;
